import type { RtPresetConfig } from '../../types'

/**
 * 官方预设的初始配置。
 * 当前按低/中/高三档提供合法值；确认最终产品参数后只需在此处调整。
 */
export const RT_PRESET_CONFIGS = [
  {
    index: 1,
    nameKey: 'rt.presets.names.official1',
    settings: {
      travel: {
        triggerPress: { left: 1, right: 1 },
      },
      rapidTrigger: {
        rtSwitch: { left: true, right: true },
        rtLevel: { left: 1, right: 1 },
      },
      vibration: {
        feedbackType: 1,
        vibrationPress: { left: 1, right: 1 },
        vibrationRelease: { left: 1, right: 1 },
      },
      sound: {
        beepPress: { left: 1, right: 1 },
        beepRelease: { left: 1, right: 1 },
        beepVolume: { left: 10, right: 10 },
      },
    },
  },
  {
    index: 2,
    nameKey: 'rt.presets.names.official2',
    settings: {
      travel: {
        triggerPress: { left: 5, right: 5 },
      },
      rapidTrigger: {
        rtSwitch: { left: true, right: true },
        rtLevel: { left: 3, right: 3 },
      },
      vibration: {
        feedbackType: 1,
        vibrationPress: { left: 5, right: 5 },
        vibrationRelease: { left: 5, right: 5 },
      },
      sound: {
        beepPress: { left: 5, right: 5 },
        beepRelease: { left: 5, right: 5 },
        beepVolume: { left: 50, right: 50 },
      },
    },
  },
  {
    index: 3,
    nameKey: 'rt.presets.names.official3',
    settings: {
      travel: {
        triggerPress: { left: 10, right: 10 },
      },
      rapidTrigger: {
        rtSwitch: { left: true, right: true },
        rtLevel: { left: 5, right: 5 },
      },
      vibration: {
        feedbackType: 1,
        vibrationPress: { left: 10, right: 10 },
        vibrationRelease: { left: 10, right: 10 },
      },
      sound: {
        beepPress: { left: 10, right: 10 },
        beepRelease: { left: 10, right: 10 },
        beepVolume: { left: 100, right: 100 },
      },
    },
  },
] as const satisfies readonly RtPresetConfig[]
